import { modalContentHabitat as Component } from './modal-content';
export default Component;
